import { useState } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { setCamBasis, setCamPos } from '../services/worldObjects';

// Publishes the camera's flattened forward/right vector for the placement
// panels. They are DOM components outside the Canvas and cannot read the camera
// themselves, but "left" has to mean left FROM WHERE YOU STAND or nothing lands
// where you expect. Writes to a plain module object rather than store state
// because this changes every frame and must not re-render anything.
export default function CameraBasisProbe() {
  const [v] = useState(() => new THREE.Vector3());
  useFrame(({ camera }) => { camera.getWorldDirection(v); setCamBasis(v); setCamPos(camera.position); });
  return null;
}
